import { React } from 'react';
import { takeLatest, put, call, takeEvery } from 'redux-saga/effects';

import { toast } from 'react-toastify';
import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import {
  APPROVAL_REQUESTS_GET,
  APPROVAL_STATUS_SET,
} from '../actions/eventApproval';
import eventApproval from '../../api/eventApproval';
import { ToastError, ToastSuccess } from '../../../ui/components/Toast';
import routes from '../../../routes';
import { errorHandling } from '../../../utils/errors';

function* approvalRequestsGet({ filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      eventApproval.getApprovalRequests,
      filters
    );
    let newRequests = false;
    if (filters?.approval_status === 'TO_BE_APPROVED') newRequests = true;
    yield put({
      type: APPROVAL_REQUESTS_GET._SUCCESS,
      response,
      pager,
      newRequests,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > eventApproval > approvalRequestsGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* approvalRequestsGetWatch() {
  yield takeEvery(APPROVAL_REQUESTS_GET._REQUEST, approvalRequestsGet);
}

function* approvalStatusSet({ id, body, navigate }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      eventApproval.approvalStatusSet,
      id,
      body
    );
    yield put({
      type: APPROVAL_STATUS_SET._SUCCESS,
      response,
    });
    toast.success(
      <ToastSuccess
        title={`Evento ${
          body?.status === 'APPROVED' ? 'approvato' : 'rifiutato'
        }`}
      />,
      {
        toastId: `approval-status-${id}`,
      }
    );
    yield navigate(routes.approvalList.path);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > eventApproval > approvalStatusSet', err);
    toast.error(<ToastError title="Qualcosa è andato storto" />);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* approvalStatusSetWatch() {
  yield takeLatest(APPROVAL_STATUS_SET._REQUEST, approvalStatusSet);
}

export default [approvalRequestsGetWatch(), approvalStatusSetWatch()];
